import React, { useEffect, useState } from 'react';

function useWebWorker(Worker, message, callback) {
  const [worker, setWorker] = useState();

  useEffect(() => {
    const worker = new Worker();
    setWorker(worker);
    worker.onmessage = (event) => callback(event.data);

    return () => {
      worker.terminate();
    };
  }, [Worker, callback]);

  useEffect(() => {
    if (message && worker) {
      worker.postMessage(message);
    }
  }, [worker, message]);
}

export default useWebWorker;
